import { ACTION_TYPES } from './reducers'

export const clearRows = (dispatch) => {
    dispatch({ type: ACTION_TYPES.CLEAR_ROWS })
}